<div [ngStyle]="{width: width}" class="facility-icon-wrapper">
  <div class="itelycare-logo" fxLayoutAlign="start center">
    <img *ngIf="logo == 'light'" src="assets/images/intelycare-logo-primary-tm-logo-full-color-rgb.svg">
    <img *ngIf="logo == 'blue'" src="assets/images/intelycare-logo-primary-tm-logo-full-color-rgb.svg" style="height: 24px;">
  </div>
</div>
